var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "singleLineMultiline"
  }, [_vm.itemData.partsType === "singleLine" ? [_c("div", [_vm.itemData.prefix ? _c("span", {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.itemData.prefix)))]) : _vm._e(), _c("a-input", {
    style: {
      width: _vm.itemData.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.itemData.promptText),
      disabled: !_vm.isEdit
    },
    on: {
      blur: _vm.blurFun
    },
    model: {
      value: _vm.formData[_vm.itemData.mark],
      callback: function ($$v) {
        _vm.$set(_vm.formData, _vm.itemData.mark, $$v);
      },
      expression: "formData[itemData.mark]"
    }
  }), _vm.itemData.suffix ? _c("span", {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.itemData.suffix)))]) : _vm._e()], 1)] : _vm.itemData.partsType === "multiline" ? [_c("div", [_c("a-input", {
    style: {
      width: _vm.itemData.widthSet
    },
    attrs: {
      type: "textarea",
      placeholder: _vm.$t(_vm.itemData.promptText),
      disabled: !_vm.isEdit
    },
    on: {
      blur: _vm.blurFun
    },
    model: {
      value: _vm.formData[_vm.itemData.mark],
      callback: function ($$v) {
        _vm.$set(_vm.formData, _vm.itemData.mark, $$v);
      },
      expression: "formData[itemData.mark]"
    }
  })], 1)] : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };